/*------------------------------------------------------------------------------

  メインビジュアル

------------------------------------------------------------------------------*/
$(function() {
  // サムネイル
  let sliderThumbnail = new Swiper('.slider-thumbnail', {
    slidesPerView: 3,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.slider-thumbnail .swiper-button-next',
      prevEl: '.slider-thumbnail .swiper-button-prev',
    },
  });

  //メインスライダー
  let mySwiper = new Swiper('.mv_swiper-container.slider-main', {
    loop: true,
    effect: "fade",
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      768: {
        allowTouchMove: true,
      }
    },
    on: {
      init: function() {
        realIndex = this.realIndex;
        activeIndex = realIndex + 1;
        $('.mv_content_number').text('0' + activeIndex);
      },
      slideChange: function() {
        realIndex = this.realIndex;
        activeIndex = realIndex + 1;
        if(activeIndex > 9) {
          $('.mv_content_number').text(activeIndex);
        } else {
          $('.mv_content_number').text('0' + activeIndex);
        }
      },
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
  });
});

/*------------------------------------------------------------------------------

  東ソーの挑戦

------------------------------------------------------------------------------*/
$(function() {
  let mySwiper = new Swiper('.challenge_swiper-container', {
    effect: 'coverflow',
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: false,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.challenge_swiper-container .swiper-button-next',
      prevEl: '.challenge_swiper-container .swiper-button-prev',
    },
  });
});

/*------------------------------------------------------------------------------

  事業・製品

------------------------------------------------------------------------------*/
$(function() {
  let index;

  $('.top_search_content_tab_item').on('click', function() {
    index = $(this).index();

    // 事業・製品タブ
    $('.top_search_content_tab_item').removeClass('current');
    $(this).addClass('current');

    // 事業・製品コンテンツ
    $('.top_search_content_link_clm').hide();
    $('.top_search_content_link_clm').eq(index).show();
  });
});
